import sliceCreator from '../../index.js';
import {GET_ORDER} from '../../../constants/index.js';
const _getOrderAction = sliceCreator('GET_ORDER',GET_ORDER, 'get');

const { asyncAction: getOrderAction, reducer, clearData: cleargetOrderData } = _getOrderAction;

export default reducer;

export {
    getOrderAction,
    cleargetOrderData
}


